/* eslint-disable */ import { EnumReflection } from '@salsita-ai/platform-project-sdk/domain';
export const ApplicationVersion = '1.4.19';
export const PublishedData = {
    type: 'object',
    properties: {
        presetCategories: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'string'
                    },
                    name: {
                        anyOf: [
                            {
                                type: 'string'
                            },
                            {
                                import: [
                                    {
                                        module: '@salsita-ai/platform-common/utils',
                                        member: 'MultilingualString'
                                    }
                                ],
                                tsType: 'MultilingualString',
                                type: 'object',
                                properties: {
                                    $lang: {
                                        type: 'object',
                                        additionalProperties: {
                                            type: 'string'
                                        }
                                    }
                                },
                                required: [
                                    '$lang'
                                ],
                                additionalProperties: false
                            }
                        ]
                    },
                    description: {
                        anyOf: [
                            {
                                type: 'string'
                            },
                            {
                                import: [
                                    {
                                        module: '@salsita-ai/platform-common/utils',
                                        member: 'MultilingualString'
                                    }
                                ],
                                tsType: 'MultilingualString',
                                type: 'object',
                                properties: {
                                    $lang: {
                                        type: 'object',
                                        additionalProperties: {
                                            type: 'string'
                                        }
                                    }
                                },
                                required: [
                                    '$lang'
                                ],
                                additionalProperties: false
                            }
                        ]
                    },
                    img: {
                        type: 'string'
                    },
                    imgAlt: {
                        anyOf: [
                            {
                                type: 'string'
                            },
                            {
                                import: [
                                    {
                                        module: '@salsita-ai/platform-common/utils',
                                        member: 'MultilingualString'
                                    }
                                ],
                                tsType: 'MultilingualString',
                                type: 'object',
                                properties: {
                                    $lang: {
                                        type: 'object',
                                        additionalProperties: {
                                            type: 'string'
                                        }
                                    }
                                },
                                required: [
                                    '$lang'
                                ],
                                additionalProperties: false
                            }
                        ]
                    },
                    presets: {
                        type: 'array',
                        items: {
                            type: 'object',
                            properties: {
                                configurationId: {
                                    type: 'string'
                                },
                                revisionId: {
                                    type: 'string'
                                },
                                readToken: {
                                    type: 'string'
                                },
                                name: {
                                    anyOf: [
                                        {
                                            type: 'string'
                                        },
                                        {
                                            import: [
                                                {
                                                    module: '@salsita-ai/platform-common/utils',
                                                    member: 'MultilingualString'
                                                }
                                            ],
                                            tsType: 'MultilingualString',
                                            type: 'object',
                                            properties: {
                                                $lang: {
                                                    type: 'object',
                                                    additionalProperties: {
                                                        type: 'string'
                                                    }
                                                }
                                            },
                                            required: [
                                                '$lang'
                                            ],
                                            additionalProperties: false
                                        }
                                    ]
                                },
                                description: {
                                    anyOf: [
                                        {
                                            type: 'string'
                                        },
                                        {
                                            import: [
                                                {
                                                    module: '@salsita-ai/platform-common/utils',
                                                    member: 'MultilingualString'
                                                }
                                            ],
                                            tsType: 'MultilingualString',
                                            type: 'object',
                                            properties: {
                                                $lang: {
                                                    type: 'object',
                                                    additionalProperties: {
                                                        type: 'string'
                                                    }
                                                }
                                            },
                                            required: [
                                                '$lang'
                                            ],
                                            additionalProperties: false
                                        }
                                    ]
                                },
                                img: {
                                    type: 'string'
                                },
                                imgAlt: {
                                    anyOf: [
                                        {
                                            type: 'string'
                                        },
                                        {
                                            import: [
                                                {
                                                    module: '@salsita-ai/platform-common/utils',
                                                    member: 'MultilingualString'
                                                }
                                            ],
                                            tsType: 'MultilingualString',
                                            type: 'object',
                                            properties: {
                                                $lang: {
                                                    type: 'object',
                                                    additionalProperties: {
                                                        type: 'string'
                                                    }
                                                }
                                            },
                                            required: [
                                                '$lang'
                                            ],
                                            additionalProperties: false
                                        }
                                    ]
                                },
                                detailTitle: {
                                    type: 'string'
                                },
                                detailDescription: {
                                    type: 'string'
                                },
                                tags: {
                                    type: 'array',
                                    items: {
                                        type: 'string'
                                    }
                                }
                            },
                            required: [
                                'configurationId',
                                'revisionId',
                                'readToken',
                                'name',
                                'description'
                            ],
                            additionalProperties: false
                        }
                    }
                },
                required: [
                    'id',
                    'name',
                    'presets'
                ],
                additionalProperties: false
            }
        },
        recipes: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'string'
                    },
                    name: {
                        anyOf: [
                            {
                                type: 'string'
                            },
                            {
                                import: [
                                    {
                                        module: '@salsita-ai/platform-common/utils',
                                        member: 'MultilingualString'
                                    }
                                ],
                                tsType: 'MultilingualString',
                                type: 'object',
                                properties: {
                                    $lang: {
                                        type: 'object',
                                        additionalProperties: {
                                            type: 'string'
                                        }
                                    }
                                },
                                required: [
                                    '$lang'
                                ],
                                additionalProperties: false
                            }
                        ]
                    },
                    description: {
                        anyOf: [
                            {
                                type: 'string'
                            },
                            {
                                import: [
                                    {
                                        module: '@salsita-ai/platform-common/utils',
                                        member: 'MultilingualString'
                                    }
                                ],
                                tsType: 'MultilingualString',
                                type: 'object',
                                properties: {
                                    $lang: {
                                        type: 'object',
                                        additionalProperties: {
                                            type: 'string'
                                        }
                                    }
                                },
                                required: [
                                    '$lang'
                                ],
                                additionalProperties: false
                            }
                        ]
                    },
                    collection: {
                        type: 'string'
                    },
                    configuration: {
                        type: 'object',
                        properties: {
                            modelVersion: {
                                type: 'number'
                            },
                            entities: {
                                type: 'array',
                                items: {
                                    type: 'object',
                                    properties: {
                                        id: {
                                            type: 'string'
                                        },
                                        type: {
                                            type: 'string'
                                        }
                                    },
                                    required: [
                                        'id',
                                        'type'
                                    ],
                                    additionalProperties: true
                                }
                            },
                            rootEntityType: {
                                type: 'string'
                            },
                            recipeIds: {
                                type: 'array',
                                items: {
                                    type: 'string'
                                }
                            }
                        },
                        required: [
                            'modelVersion',
                            'entities',
                            'rootEntityType',
                            'recipeIds'
                        ],
                        additionalProperties: false
                    }
                },
                required: [
                    'id',
                    'name',
                    'description',
                    'collection',
                    'configuration'
                ],
                additionalProperties: false
            }
        }
    },
    additionalProperties: false,
    required: []
};
export const PublishedDataHash = '5c265efbdb9c';
export const SessionData = {};
export const FrontendData = {
    type: 'object',
    properties: {
        customerTags: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        shareBaseUrl: {
            type: 'string'
        }
    },
    required: [
        'customerTags',
        'shareBaseUrl'
    ],
    additionalProperties: false
};
export const FinalizeData = {
    type: 'object',
    properties: {
        emailAddress: {
            type: 'string'
        }
    },
    required: [
        'emailAddress'
    ],
    additionalProperties: false
};
export const PrefetchedFinalizeData = {};
export const FinalizeResult = {
    type: 'object',
    properties: {
        emailAddress: {
            type: 'string'
        },
        pdfLink: {
            type: 'string'
        }
    },
    required: [
        'emailAddress',
        'pdfLink'
    ],
    additionalProperties: false
};
export const CallbackData = {
    type: 'object',
    properties: {
        emailAddress: {
            type: 'string'
        }
    },
    required: [
        'emailAddress'
    ],
    additionalProperties: false
};
export const BackendData = {
    type: 'object',
    properties: {
        productVariants: {
            type: 'object',
            additionalProperties: {
                type: 'object',
                properties: {
                    id: {
                        type: 'string'
                    },
                    displayName: {
                        type: 'string'
                    },
                    price: {
                        type: 'number'
                    },
                    customerTagPriceOverride: {
                        type: 'number'
                    }
                },
                required: [
                    'id',
                    'displayName',
                    'price'
                ],
                additionalProperties: false
            }
        }
    },
    required: [
        'productVariants'
    ],
    additionalProperties: false
};
export const NavigationState = new EnumReflection('NavigationState', {
    enum: [
        'Build',
        'Properties',
        'Summary',
        'Finalize'
    ]
});
export const ViewState = new EnumReflection('ViewState', {
    enum: [
        'FloorPlan',
        '3dView'
    ]
});
export const ToolState = new EnumReflection('ToolState', {
    enum: [
        'Sketching',
        'Selection'
    ]
});
export const ExportState = new EnumReflection('ExportState', {
    enum: [
        'Default'
    ]
});
export const AdminNavigationState = new EnumReflection('AdminNavigationState', {
    enum: [
        'Default'
    ]
});
export const AdminViewState = new EnumReflection('AdminViewState', {
    enum: [
        'Default'
    ]
});
export const $dataSpec = {
    custom: {},
    swatchOptions: {}
};
export const $adminPagesSpec = {};

//# sourceMappingURL=application-types.js.map